import request from "@/utils/request"
//学院

//学院概述-校园风貌-getAl
export function getFeatures() {
  return request({
    url: "/web/features/setting/getAll",
    method: "get"
  })
}
//学院概述-校园风貌-分页列表
export function getFeaturesList(data) {
  return request({
    url: "/web/features/setting/list",
    method: "get",
    params: data
  })
}
//学院概述-校园风貌-getOneById
export function getFeaturesById(data) {
  return request({
    url: "/web/features/setting/get/one",
    method: "get",
    params: data
  })
}
//学院概述-学院介绍&机构设置-getAll
export function getSituation(data) {
  return request({
    url: "/web/situation/setting/getAll",
    method: "get",
    params: data
  })
}
//学院概述-学院介绍&机构设置-分页列表
export function getSituationList(data) {
  return request({
    url: "/web/situation/setting/list",
    method: "get",
    params: data
  })
}
//学院概述-学院介绍&机构设置-getOneById
export function getSituationById(data) {
  return request({
    url: "/web/situation/setting/get/one",
    method: "get",
    params: data
  })
}

//现任领导
export function leaderList(data) {
  return request({
    // url: "/manager/leader/setting/list",
    url: "/web/leader/setting/list",
    method: "get",
    params: data
  })
}
